import { Button } from '@/components/ui/button';
import { formatExplainAccess } from '@/lib/users-roles/explain-access';
import type { ExplainAccessInput } from '@/lib/users-roles/types';

export function ExplainAccessPanel({ diagnostic }: { diagnostic: ExplainAccessInput }) {
  const text = formatExplainAccess(diagnostic);

  return (
    <div className="space-y-2" data-testid="explain-access-panel">
      <h4 className="font-medium text-sm">Why?</h4>
      <pre className="overflow-auto rounded-md border border-border bg-muted/40 p-3 text-xs text-foreground whitespace-pre-wrap">
        {text}
      </pre>
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={() => void navigator.clipboard.writeText(text)}
      >
        Copy diagnostic
      </Button>
    </div>
  );
}
